import { render, staticRenderFns } from "./TabAttentions.vue?vue&type=template&id=0fd1968e&"
import script from "./TabAttentions.vue?vue&type=script&lang=ts&"
export * from "./TabAttentions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports